// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RoT4","left":"styles_left__1cajM"};